(ns practitest.frontend.gauge-chart-config
  (:require
    [cljs.reader]
    [goog.string]
    [practitest.frontend.init :as init]
    [re-frame.core :as re-frame]))

;; subs
(re-frame/reg-sub
  ::state
  (fn [db _]
    (:gauge-state db)))

(re-frame/reg-sub
  ::value
  :<- [::state]
  (fn [state [_ id field]]
    (cljs.reader/read-string (get-in state [id field]))))

;; events
(re-frame/reg-event-db
  ::update-state-values
  (fn [db [_ data]]
    (let [value-position (if (= (:val-id data) "first-val") 0 1)
          new-value (goog.string/parseInt (:new-val data))
          item-id (:item-id data)

          existing-config (get-in db [:gauge-state item-id :data-gauge-config])
          parsed-value (cljs.reader/read-string existing-config)
          modified-value (assoc parsed-value value-position new-value)
          str-value (cljs.core/pr-str modified-value)]
        (when-let [node (js/document.getElementById "gauge_chart_config")]
          (set! (.-value node) str-value))
      (assoc-in db [:gauge-state item-id :data-gauge-config] str-value))))

(re-frame/reg-event-db
  ::write-attrs-to-db
  (fn [db [_ data]]
    (let [item-id (:data-item-id data)]
      (update-in db [:gauge-state item-id] merge data))))

(defn draw-dot [color]
  [:div.draw-dot
   {:style {:background-color color}}])

(defn input-div [{:keys [min max disabled value on-change on-blur]}]
  [:div.input-container
   [:input.gauge-input-field {:type        "number"
                              :placeholder ""
                              :min         min
                              :max         max
                              :disabled    disabled
                              :value       value
                              :on-change   on-change
                              :on-blur     on-blur}]])

(defn gauge-config-row [{:keys [item-id
                                label color
                                first-id second-id
                                first-val second-val
                                first-disabled second-disabled
                                first-min
                                first-max
                                second-min
                                second-max
                                ]}]
  [:div.col-6.gauge-config-row
   [:div.col-4.dot-container
    [draw-dot color]
    label]
    [input-div {:min       first-min
                :max       first-max
                :disabled  first-disabled
                :value     first-val
                :on-change (fn [e]
                            (re-frame/dispatch-sync [::update-state-values {:item-id item-id
                                                                            :val-id  first-id
                                                                            :new-val (-> e .-target .-value)}]))
                :on-blur (fn [e]
                          (let [value (-> e .-target .-value)
                                validated-value (cond
                                                (< value first-min) first-min
                                                (> value first-max) first-max
                                                :else value)]
                                (re-frame/dispatch [::update-state-values {:item-id item-id
                                                                           :val-id  first-id
                                                                           :new-val validated-value}])))}]
    [:div {:style {:display     "flex"
                  :align-items "center"}}
    "-"]
    [input-div {:min       second-min
                :max       second-max
                :disabled  second-disabled
                :value     second-val
                :on-change (fn [e]
                            (re-frame/dispatch-sync [::update-state-values {:item-id item-id
                                                                            :val-id  second-id
                                                                            :new-val (-> e .-target .-value)}]))
                :on-blur   (fn [e]
                            (let [value (-> e .-target .-value)
                                  validated-value (cond
                                                  (< value second-min) second-min
                                                  (> value second-max) second-max
                                                  :else value)]
                            (re-frame/dispatch [::update-state-values {:item-id item-id
                                                                       :val-id  second-id
                                                                       :new-val validated-value}])))}]
    ])

(defn display-gauge-config [data-item-id]
  (let [config @(re-frame/subscribe [::value data-item-id :data-gauge-config])
        first-val (first config)
        second-val (second config)]
    [:div.col-6.control-label.gauge-config
     "Gauge configuration"
     [gauge-config-row {:item-id         data-item-id
                        :label           "Bad"
                        :color           "#FF3F3F"
                        :first-id        "start-val"
                        :second-id       "first-val"
                        :first-val       0
                        :second-val      first-val
                        :first-disabled  true
                        :second-disabled false
                        :first-min       0
                        :first-max       0
                        :second-min      1
                        :second-max      (- second-val 1)
                        }]
     [gauge-config-row {:item-id         data-item-id
                        :label           "Medium"
                        :color           "#FFB800"
                        :first-id        "first-val"
                        :second-id       "second-val"
                        :first-val       first-val
                        :second-val      second-val
                        :first-disabled  false
                        :second-disabled false
                        :first-min       1
                        :first-max       (- second-val 1)
                        :second-min      (+ first-val 1)
                        :second-max      99
                        }]
     [gauge-config-row {:item-id         data-item-id
                        :label           "Good"
                        :color           "#2DD113"
                        :first-id        "second-val"
                        :second-id       "end-val"
                        :first-val       second-val
                        :second-val      100
                        :first-disabled  false
                        :second-disabled true
                        :first-min       (+ first-val 1)
                        :first-max       99
                        :second-min      100
                        :second-max      100
                        }]]))

(defn root-view [{:keys [data-item-id]
                  :as   attrs}]

  (re-frame/dispatch [::write-attrs-to-db attrs])
  [display-gauge-config data-item-id])

(defn ^:dev/after-load remount-roots []
  ;; remount all comment item components on page
  (init/remount-roots "gauge-chart-config-component"
                      root-view))
